import { useState, useRef, useEffect } from "react";
import { Popover } from "antd";
import { FacebookOutlined, CopyOutlined } from "@ant-design/icons";

const InterviewImageLink = ({ handleImageLink, content, width, height }) => {
  const [englishImageState, setEnglishImageState] = useState(null);
  const [arabicImageState, setArabicImageState] = useState(null);
  const dateEngRef = useRef(null);
  const dateArabRef = useRef(null);
  const descriptionEngRef = useRef(null);
  const descriptionArabRef = useRef(null);
  const popoverContent = (
    <div className="interview-share-popover-list">
      <li>
        <FacebookOutlined />
      </li>
      <li>
        <CopyOutlined />
      </li>
    </div>
  );

  // dynamic height of the interview text
  // window.innerHeight - 129 is the fixed height of the main block that sits between the header and the footer
  // offsetTop is whatever header there is in the main box
  useEffect(() => {
    if (width > 1124) {
      const offsetTop = dateEngRef.current.offsetTop;
      descriptionEngRef.current.style.height = `calc(${
        height - offsetTop - 129
      }px + ${window.getComputedStyle(dateEngRef.current)["height"]} + ${
        window.getComputedStyle(dateEngRef.current)["margin-top"]
      })`;
    }
  }, [dateEngRef, descriptionEngRef, width, height]);
  useEffect(() => {
    if (width > 1124) {
      const offsetTop = dateArabRef.current.offsetTop;
      descriptionArabRef.current.style.height = `calc(${
        height - offsetTop - 129
      }px + ${window.getComputedStyle(dateArabRef.current)["height"]} + ${
        window.getComputedStyle(dateArabRef.current)["margin-top"]
      })`;
    }
  }, [dateArabRef, descriptionArabRef, width, height]);

  return (
    <div
      className="interview-link"
      style={{ height: window.innerHeight - 129 }}
    >
      {arabicImageState && (
        <img
          src={`/images/interviewContent/${arabicImageState}`}
          style={{ width: "50%", objectFit: "cover" }}
          alt="Interview"
        ></img>
      )}
      <div
        className="interview-link-english"
        style={{
          opacity: englishImageState ? "0.5" : englishImageState && "0.5",
          display: arabicImageState ? "none" : arabicImageState && "none",
        }}
      >
        <div
          className="interview-link-english-back"
          onClick={() => {
            handleImageLink(false);
          }}
        >
          <img
            src="/icons/red_arrow_back.svg"
            alt="Back"
            style={{ width: "25px", margin: "0 2% 0 0" }}
          />
          <span className="interview-link-english-back-eng">
            back to interviews •{" "}
          </span>
          <span className="interview-link-english-back-arab">
            عودة إلى المقابلات
          </span>
        </div>
        <div className="interview-link-english-name">
          {content.english.title}
        </div>
        <div ref={dateEngRef} className="interview-link-english-date">
          {content.english.date} /&nbsp;
          <span className="interview-link-english-date-share">
            <Popover
              content={popoverContent}
              title="Title"
              overlayClassName="interview-share-popover"
              placement="bottom"
            >
              share
            </Popover>
          </span>
        </div>
        <div
          className="interview-link-english-description"
          ref={descriptionEngRef}
        >
          {content.english.text.map((text, textIndex) => {
            // make the text between **'s bold, then every text is searched for and linked with an image
            const parts = text.split(/\*\*/g);
            // if it is a question and it's not the first one, add a bigger margin top
            const marginTop =
              textIndex !== 0 &&
              text.slice(0, 2) === "**" &&
              text.slice(text.length - 2) === "**"
                ? "5%"
                : "1.3%";
            const marginBottom =
              textIndex === content.english.text.length - 1 ? "5%" : "0%";
            return (
              <div style={{ marginTop: marginTop, marginBottom: marginBottom }}>
                {parts.map((part, partIndex) => {
                  part = part.split(/\$\$/g);
                  let newPart = part.map((subpart, subpartIndex) => {
                    if (subpartIndex % 3 === 0) {
                      return <span key={subpartIndex}>{subpart}</span>;
                    } else if (subpartIndex % 3 === 1) {
                      return (
                        <span
                          key={subpartIndex}
                          className="interview-link-english-description-link"
                          onMouseEnter={() =>
                            setEnglishImageState(part[subpartIndex + 1])
                          }
                          onMouseLeave={() => setEnglishImageState(null)}
                        >
                          {subpart}
                        </span>
                      );
                    }
                  });
                  if (partIndex % 2 === 0) {
                    return (
                      <span
                        className="mobile-interview-link-english-description-answer"
                        key={partIndex}
                      >
                        {newPart}
                      </span>
                    );
                  } else {
                    return (
                      <span
                        className="mobile-interview-link-english-description-question"
                        key={partIndex}
                      >
                        {newPart}
                      </span>
                    );
                  }
                })}
              </div>
            );
          })}
        </div>
      </div>

      {englishImageState && (
        <img
          src={`/images/interviewContent/${englishImageState}`}
          style={{ width: "50%", objectFit: "cover" }}
          alt="Interview"
        ></img>
      )}
      <div
        className="interview-link-arabic"
        style={{
          opacity: arabicImageState ? "0.5" : arabicImageState && "0.5",
          display: englishImageState ? "none" : englishImageState && "none",
        }}
      >
        <div className="interview-link-arabic-name">{content.arabic.title}</div>
        <div className="interview-link-arabic-date" ref={dateArabRef}>
          {content.arabic.date} &nbsp;/ &nbsp;
          <span className="interview-link-arabic-date-share">
            <Popover
              content={popoverContent}
              title="Title"
              overlayClassName="interview-share-popover"
              placement="bottom"
            >
              نشـــــر
            </Popover>
          </span>
        </div>
        <div
          className="interview-link-arabic-description"
          ref={descriptionArabRef}
        >
          {content.arabic.text.map((text, textIndex) => {
            // make the text between **'s bold, then every text is searched for and linked with an image
            const parts = text.split(/\*\*/g);
            // if it is a question and it's not the first one, add a bigger margin top
            const marginTop =
              textIndex !== 0 &&
              text.slice(0, 2) === "**" &&
              text.slice(text.length - 2) === "**"
                ? "5%"
                : "1.3%";
            const marginBottom =
              textIndex === content.arabic.text.length - 1 ? "5%" : "0%";
            return (
              <div style={{ marginTop: marginTop, marginBottom: marginBottom }}>
                {parts.map((part, partIndex) => {
                  part = part.split(/\$\$/g);
                  let newPart = part.map((subpart, subpartIndex) => {
                    if (subpartIndex % 3 === 0) {
                      return <span key={subpartIndex}>{subpart}</span>;
                    } else if (subpartIndex % 3 === 1) {
                      return (
                        <span
                          key={subpartIndex}
                          className="interview-link-arabic-description-link"
                          onMouseEnter={() =>
                            setArabicImageState(part[subpartIndex + 1])
                          }
                          onMouseLeave={() => setArabicImageState(null)}
                        >
                          {subpart}
                        </span>
                      );
                    }
                  });
                  if (partIndex % 2 === 0) {
                    return (
                      <span
                        className="mobile-interview-link-arabic-description-answer"
                        key={partIndex}
                      >
                        {newPart}
                      </span>
                    );
                  } else {
                    return (
                      <span
                        className="mobile-interview-link-arabic-description-question"
                        key={partIndex}
                      >
                        {newPart}
                      </span>
                    );
                  }
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InterviewImageLink;
